import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./Styles";
import CustomizedSelect from "./CustomizedSelect";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const FilterTogglebar = (props) => {
  const classes = useStyles();
  const { water_user_options } = useSelector(
    (state) => state.water_user
  );
  const {
    // title,
    options,
    handleChange,
    // value,
    scenario_disabled,
    water_user_disabled,
  } = props;
  const [selectedValue, setSelectedValue] = React.useState(1);
  const [selectedScenarioValue, setSelectedScenarioValue] = React.useState(1);
  const isInitialMount = React.useRef(true);
  const { isMobile } = useGetViewPortDimensions();

  const scenario_options = [
    { label: "Drought Contingency Plan Stages", value: 1 },
    { label: "More Severe", value: 2 },
  ];

  const handleSelectedItem = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleSelectedScenario = (e) => {
    setSelectedScenarioValue(e.target.value);
  };

  // Reset selectedValue to index 0 on change of water user options
  React.useEffect(() => {
    setSelectedValue(1);
  }, [water_user_options]);

  const hookDependency = () => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      handleChange(selectedValue, selectedScenarioValue);
    }
  }
  React.useEffect(hookDependency, [selectedValue, selectedScenarioValue]);

  return (
    <Grid container classes={{ root: isMobile ? classes.filterContainerResponsive : classes.filterContainer }}>
      <CustomizedSelect
        label="Water User Filter"
        dropdownValue={selectedValue}
        options={options}
        handleSelectedItem={handleSelectedItem}
        disabled={water_user_disabled}
      />
      <CustomizedSelect
        label="Scenario"
        dropdownValue={selectedScenarioValue}
        options={scenario_options}
        handleSelectedItem={handleSelectedScenario}
        disabled={scenario_disabled}
      />
    </Grid>
  );
};

FilterTogglebar.defaultProps = {
  scenario_disabled: false,
  water_user_disabled: false,
};

export default FilterTogglebar;
